const UserDetailTelemetryEventNames = {
  UserDetails_getCurrentUserWorkspaceGroupAffinity_defaults: "UserDetails_getCurrentUserWorkspaceGroupAffinity_defaults",
  UserDetails_getCurrentUserWorkspaceGroupAffinity_userAffinity: "UserDetails_getCurrentUserWorkspaceGroupAffinity_userAffinity"
};
export {
  UserDetailTelemetryEventNames
};
//# sourceMappingURL=UserDetailTelemetryEventNames.js.map
